/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DeploymentCheckKind {
	HEALTH = "health",
	READY = "ready",
}
